// extracted by mini-css-extract-plugin
export default {"wrapper":"drawer_wrapper__sQPkb","close-button-container":"drawer_close-button-container__CYzaA","container":"drawer_container__83DVl","footer":"drawer_footer__XcAhR"};